export default __webpack_public_path__ + "static/media/13.2be94984.png";